import "./Header.html";
import "./Header.scss";

import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import "angular-breadcrumb";
import HeaderComponentController from "./HeaderComponentController";

export class HeaderComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {};
        this.controller = HeaderComponentController;
        this.templateUrl = "/App/Components/Core/Header/Header.html";
    }
}

module("mmManagePortal").component("mmHeader", new HeaderComponent());
